import { formatMandataire } from "~/formatters/mandataires";

export const formatGestionnaire = (row) => formatMandataire(row);
